export const UPDATE_MANDATO_INVIA            	= 'UPDATE_MANDATO_INVIA';
export const SALVA_DATI_INVIA_NUOVE_CREDENZIALI	= 'SALVA_DATI_INVIA_NUOVE_CREDENZIALI';